import { render, staticRenderFns } from "./speech-area.vue.js?vue&type=template&id=6bb779cd!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./speech-area.vue?vue&type=template&id=6bb779cd"
import script from "./speech-area.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./speech-area.vue?vue&type=script&lang=js"
export * from "./speech-area.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./speech-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports